import { render, staticRenderFns } from "./KGCKDOLL.vue?vue&type=template&id=15049cbd&scoped=true"
import script from "./KGCKDOLL.vue?vue&type=script&lang=js"
export * from "./KGCKDOLL.vue?vue&type=script&lang=js"
import style0 from "./KGCKDOLL.vue?vue&type=style&index=0&id=15049cbd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15049cbd",
  null
  
)

export default component.exports